// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__rVQKD","inner":"Footer_inner__xeZdK","text":"Footer_text__lUGV0"};